module.exports = __webpack_public_path__ + "img/zyzdw-icon.9b0613df.png";